// Steuert, welche Felder (Icon/Farbe) der Bearbeiten-Dialog und die Tabelle
// für eine bestimmte Liste anzeigen. Neue Listen ohne Eintrag hier bekommen
// standardmäßig nur Name/Wert (kein Icon, keine Farbe).

export interface ListSettingsFieldConfig {
  hasIcon: boolean;
  hasColor: boolean;
  labelPlaceholder: string;
  valuePlaceholder: string;
}

export const LIST_SETTINGS_FIELD_CONFIG: Record<
  string,
  ListSettingsFieldConfig
> = {
  'Dokumenten Upload Typ': {
    hasIcon: true,
    hasColor: true,
    labelPlaceholder: 'z.B. Vertrag',
    valuePlaceholder: 'Keine Umlaute, alles aneinander',
  },
  'Dozenten (festangestellt)': {
    hasIcon: false,
    hasColor: false,
    labelPlaceholder: 'z.B. Max Mustermann',
    valuePlaceholder: 'Gleicher Inhalt wie oben!',
  },
};

export const DEFAULT_LIST_SETTINGS_FIELD_CONFIG: ListSettingsFieldConfig = {
  hasIcon: false,
  hasColor: false,
  labelPlaceholder: 'Name',
  valuePlaceholder: 'Keine Umlaute, alles aneinander',
};

export function getListSettingsFieldConfig(
  listName: string | null | undefined,
): ListSettingsFieldConfig {
  return (
    (listName && LIST_SETTINGS_FIELD_CONFIG[listName]) ||
    DEFAULT_LIST_SETTINGS_FIELD_CONFIG
  );
}
